<template>
  <div class="car-unpetrified-com">
    <div class="header">
      <div>停靠非石化加油站企业列表</div>
      <el-form :inline="true" :model="conditon" style="margin-top:20px; ">
        <el-form-item label="统计月份">
          <el-date-picker style="width: 150px;" v-model="conditon.time" type="month" placeholder="选择月" format="yyyy年MM月" value-format="yyyyMM"></el-date-picker>
        </el-form-item>
        <el-form-item label="省份">
          <el-select v-model="conditon.provCode" placeholder="不限" style="width:150px;">
            <el-option label="不限" value></el-option>
            <el-option v-show="provinceList.length" v-for="(item,index) in provinceList" :key="index" :label="item.provinceName" :value="item.provinceCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="停靠石化油站次数占比">
          <el-select v-model="conditon.range" placeholder="不限" style="width:150px;">
            <el-option label="不限" value></el-option>
            <el-option v-for="(range) in rangeList" :label="range.label" :value="range.value" :key="range.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onDebounceSearch">查询</el-button>
          <el-button @click="onPrev">返回上级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <main>
      <el-table :data="tableData" :max-height="tableHeight" stripe>
        <el-table-column type="index" width="50" align="center" label="序号"></el-table-column>
        <el-table-column prop="companyNameMask" width="300" align="center" label="企业名称">
          <template slot-scope="scope">
            <span v-if="scope.row.decryptedCompanyName">{{ scope.row.companyName }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer" @click="scope.row.decryptedCompanyName = true">{{
                scope.row.companyNameMask
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="provname" width="100" align="center" label="所属省份"></el-table-column>
        <el-table-column prop="cardCount" width="150" align="center" label="柴油卡办卡数量">
          <template slot-scope="scope">
            {{ format(scope.row.cardCount)}}
          </template>
        </el-table-column>
        <el-table-column prop="lastOpetime" width="150" align="center" label="最后一次消费时间"></el-table-column>
        <el-table-column prop="vehicleCountMask" width="150" align="center" label="车辆数">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.decryptedVehicleCount">{{ format(scope.row.vehicleCount)}}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer; padding: 0 10px;" @click="scope.row.decryptedVehicleCount = true">{{
                scope.row.vehicleCountMask
              }}</span>
            </el-tooltip>
          </template> -->
        </el-table-column>
        <el-table-column prop="vehicleOperatorCount" width="180" align="center" label="运营车辆数">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.decryptedVehicleOperatorCount">{{ format(scope.row.vehicleOperatorCount) }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer; padding: 0 10px;" @click="scope.row.decryptedVehicleOperatorCount = true">{{
                scope.row.vehicleOperatorCountMask
              }}</span>
            </el-tooltip>
          </template> -->
        </el-table-column>
        <el-table-column prop="mileageMask" width="150" align="center" label="运营公里数">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.decryptedMileage">{{ format(scope.row.mileage) }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer;" @click="scope.row.decryptedMileage = true">{{
                scope.row.mileageMask
              }}</span>
            </el-tooltip>
          </template> -->
        </el-table-column>
        <el-table-column prop="runProvince" width="150" align="center" label="常运营省份按里程取top3"></el-table-column>
        <el-table-column prop="petrochemicalStopCount" width="150" align="center" label="S级油站停靠次数">
          <template slot-scope="scope">
            {{ format(scope.row.petrochemicalStopCount)}}
          </template>
        </el-table-column>
        <el-table-column prop="petroleumStopCount" width="150" align="center" label="C级油站停靠次数">
          <template slot-scope="scope">
            {{ format(scope.row.petroleumStopCount)}}
          </template>
        </el-table-column>
        <el-table-column prop="otherStopCount" width="150" align="center" label="E级油站停靠次数">
          <template slot-scope="scope">
            {{ format(scope.row.otherStopCount)}}
          </template>
        </el-table-column>
      </el-table>
    </main>
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
    </div>
  </div>
</template>

<script>
import { hideExport } from '@/utils/tools'
import http from '@/api/freight' // 请求汇总
import _ from 'lodash'

// 停靠非石化加油站企业列表
export default {
  name: 'car-unpetrified-com',
  data() {
    return {
      hideExport,
      conditon: {
        time: '',
        pvovince: '',
        city: '',
        range: '',
        provCode: '',
      },
      rangeList: [
        { label: '0%', value: '0-0' },
        { label: '0-30%', value: '0-30' },
        { label: '30-50%', value: '30-50' },
        { label: '50-80%', value: '50-80' },
        { label: '80%以上', value: '80-100' },
      ],
      provinceList: [],
      tableData: [], // 表格数据
      currentPage: 1,
      total: 0,
      pageSize: 20,

      onDebounceSearch: _.debounce(this.onSearch, 500),
    }
  },
  mounted() {
    this.getProvinceList()
    this.initDate(1)
  },
  methods: {
    getProvinceList() {
      http.carUnpetrifiedComProv().then((e) => {
        if (e.code == 200 && e.data) {
          this.provinceList = e.data
        }
      })
    },
    initDate(num = 2) {
      if (num == 2 && this.conditon.time == '') {
        this.$message({
          message: '请选择月份',
          type: 'warning',
        })
        return
      }
      // 初始化数据
      http
        .carUnpetrifiedCom({
          provCode: this.conditon.provCode ? this.conditon.provCode : null,
          cityCode: this.conditon.city ? this.conditon.city : null,
          order: 'mileage',
          percentage: this.conditon.range ? this.conditon.range : null,
          isfirst: num,
          time: this.conditon.time,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then((e) => {
          if (e.code == 200 && e.data.tPageUtil && e.data.tPageUtil.list) {
            let arr = e.data.tPageUtil.list.slice(0)
            if (e.data.conTime) {
              this.conditon.time = e.data.conTime
            }
            this.tableData = arr.map((_) => ({
              ..._,
              decryptedCompanyName: false,
              decryptedVehicleCount: false,
              decryptedMileage: false,
              decryptedVehicleOperatorCount: false,
            }))
            this.total = e.data.tPageUtil.count
            this.currentPage = e.data.tPageUtil.pageNum
          } else {
            this.tableData = []
          }
        })
    },
    handleCurrentChange(index) {
      this.currentPage = index
      this.initDate(2)
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    onSearch() {
      console.log('test')
      this.currentPage = 1
      this.total = 0
      this.initDate(2)
    },
    onPrev() {
      // 返回上级
      this.$router.push({
        name: 'carStopBrand',
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.car-unpetrified-com {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }

  .block {
    display: flex;

    .center {
      margin: 10px auto;
    }
  }
}
</style>